import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen } from 'lucide-react';

interface InterviewHeaderProps {
    title?: string;
    batchCode?: string;
    courseName?: string;
}

const InterviewHeader: React.FC<InterviewHeaderProps> = ({ 
    title = 'Interview Dashboard',
    batchCode,
    courseName 
}) => {
    return (
        <Card className="bg-gradient-to-l from-green-50 via-green-100 to-green-200">
            <CardHeader>
                <CardTitle className="text-2xl font-bold flex items-center gap-2 dark:text-gray-800">
                    <BookOpen className="w-6 h-6" />
                    {title}
                </CardTitle>
            </CardHeader>
            {(batchCode || courseName) && (
                <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {batchCode && (
                            <div>
                                <p className="text-sm text-gray-500 dark:text-green-800/80         font-bold">Batch</p>
                                <p className="text-lg font-semibold dark:text-gray-800">{batchCode}</p>
                            </div>
                        )}
                        {courseName && (
                            <div>
                                <p className="text-sm text-gray-500 dark:text-green-800/80 font-bold">Course</p>
                                <p className="text-lg font-semibold dark:text-gray-800">{courseName || 'N/A'}</p>
                            </div>
                        )}
                    </div>
                </CardContent>
            )}
        </Card>
    );
};

export default InterviewHeader;

